export default {
  mapView: {
    'routeTo': 'Útvonaltervezés ide',
    'polygonDetails': 'Sokszög adatai',
    'polygon': 'Sokszög',
    'whatIsHere': 'Mi van itt?',
    'directionsFromHere': 'Útvonaltervezés innen',
    'fitAllFeatures': 'Minden objektum megjelenítése',
    'addRouteStop': 'Megálló hozzáadása itt',
    'addDestinationToRoute': 'Úticél hozzáadása az útvonalhoz',
    'acquirePositionErrors': {
      'generic': 'Az Ön tartózkodási helyét nem sikerült beszerezni, mert nincs engedélyezve, vagy a böngészője/eszköze nem támogatja.',
      'unavailable': 'Böngészője/eszköze szerint tartózkodási helye jelenleg nem érhető el. Ellenőrizze, hogy a helymeghatározási opció/szolgáltatás megfelelően van-e beállítva.',
      'permissionDenied': 'Helyzetét nem sikerült beszerezni, mert böngészője/eszköze megtagadta a hozzáférést. Újra megpróbálhatja a böngésző/eszköz beállításainak megváltoztatásával, majd kattintson ismét a \'Tartózkodási helyem\' gombra',
      'timeout': 'Böngészője/eszköze túllépte az \'időkorlátot\', miközben megpróbálta tartózkodási helyét beszerezni. A \'Tartózkodási helyem\' gombra kattintva újra megpróbálhatja'
    },
    'yourCurrentLocation': 'Jelenlegi tartózkodási helye',
    'options': 'Beállítások',
    'polylineMeasure': {
      'bearingTextIn': 'Be',
      'bearingTextOut': 'Ki',
      'tooltipTextDragAndDelete': 'A <b>pont áthelyezéséhez</b> kattintson és húzza odébb.<br>A <b>pont törléséhez</b> nyomja le a Shift billentyűt, majd kattintson.',
      'tooltipTextResume': 'A <b>vonal folytatásához</b> nyomja le a Ctrl billentyűt majd kattintson',
      'tooltipTextDelete': 'A <b>pont törléséhez</b> nyomja le a Shift billentyűt, majd kattintson',
      'tooltipTextAdd': '<b>Pont hozzáadásához</b> nyomja le a Ctrl billentyűt, majd kattintson',
      'clearControlTitle': 'Mérések törlése',
      'measureControlTitleOn': 'Távolságmérés bekapcsolása',
      'measureControlTitleOff': 'Távolságmérés kikapcsolása',
      'unitControlTitle': {
        'text': 'Mértékegység módosítása',
        'metres': 'méter',
        'landmiles': 'mérföld',
        'nauticalmiles': 'tengeri mérföld'
      },
      'clearControlLabel': '&times',
      'measureControlLabel': '&#8614;',
      'measureControlClasses': [],
      'unitControlLabel': {
        'metres': 'm',
        'kilometres': 'km',
        'feet': 'láb',
        'landmiles': 'mérf.',
        'nauticalmiles': 't. mf.'
      }
    },
    'defineAvoidPolygon': 'Elkerülendő sokszög rajzolása',
    'defineAvoidRectangle': 'Elkerülendő téglalap rajzolása',
    'youCantIntersectPolygons': 'Az útvonal nem metszhet sokszöget',
    'polygonArea': 'Sokszög területe',
    'highlighting': 'Megjelenítve a(z):',
    'accuracy': 'Pontosság',
    'youCanCenterAtYourLocationLater': 'Bármikor térkép középpontjába állíthatja a saját jelenlegi tartózkodási helyét, ha ráklikkel a \'Tartózkodási helyem\' gombra',
    'yourLocation': 'Tartózkodási helyének felhasználása',
    'setMyLocationAsMapCenter': 'Szeretné jelenlegi tartózkodási helyét a térkép közepére helyezni? Ez javítja a helykeresés pontosságát. Engedélyeznie kell, ha a böngészője/eszköze kéri.',
    'removePlace': 'Hely eltávolítása',
    'viewOnORS': 'Megtekintés az OperRouteService-en',
    'moveMapPositionToLeft': 'Térkép közepének eltolása balra',
    'moveMapPositionToRight': 'Térkép közepének eltolása jobbra',
    'moveMapPositionToUp': 'Térkép közepének eltolása fölfelé',
    'moveMapPositionToDown': 'Térkép közepének eltolása lefelé',
    'toggleDirect': 'Váltás innen közvetlenül a következő helyre',
    'heightGraph': {
      'distance': 'Távolság',
      'elevation': 'Magasság',
      'segment_length': 'Szakasz hossza',
      'type': 'Típus',
      'legend': 'Jelmagyarázat'
    },
    'editShape': 'Alakzat szerkesztése',
    'remove': 'Eltávolítás',
    'avoidPolygonSaved': 'Elkerülendő sokszög mentve',
    'avoidPolygonRemoved': 'Elkerülendő sokszög eltávolítva',
    'avoidPolygonNotRemoved': 'Nem lehetett eltávolítani az elkerülendő sokszöget',
    'avoidPolygonNotSaved': 'Nem lehetett menteni az elkerülendő sokszöget',
    'polygonEditModeEnabled': 'Ha végzett a szerkesztéssel, kattintson bárhová a módosítások mentéséhez',
    'customTileProvider': 'Felhasználó által meghatározott egyedi térképmozaik-szolgáltató',
    'gestureHandling': {
      'touch': 'Két ujjal mozgassa a térképet',
      'scroll': 'A térkép nagyításához használja a Ctrl + egérgörgetőt',
      'scrollMac': 'A térkép nagyításához használja a ⌘ + egérgörgetőt'
    }
  }
}
